import React from 'react';
import type { ReactNode } from 'react';

import styles from './BaseWidget.module.scss';

interface BaseWidgetProps {
  children: ReactNode;
  headerIcon?: ReactNode;
  headerTitle: string;
  showNotification?: boolean;
  footer?: ReactNode;
  className?: string;
  headerAction?: ReactNode;
}

export const BaseWidget: React.FC<BaseWidgetProps> = ({
  children,
  headerIcon,
  headerTitle,
  showNotification = false,
  footer,
  className = '',
  headerAction,
}) => {
  return (
    <div className={`${styles.widget} ${className}`}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          {headerIcon && <div className={styles.icon}>{headerIcon}</div>}
          <h3 className={styles.title}>{headerTitle}</h3>
        </div>
        {headerAction && <div className={styles.headerAction}>{headerAction}</div>}
        {showNotification && <div className={styles.notification} />}
      </div>

      <div className={styles.body}>{children}</div>

      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};
